export const TEXT = {
  ACTION_RETURN_TITLE: {id: 'account.currentLK.return_link'},
  ACTION_RETURN_LINK: {id: 'myLK.checkoutDone.return_link'},
};

export const RETURN_INSTRUCTIONS_PARAM = 'returnInstructions';
